import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useCallback} from 'react'

import {ViewStateActionTypes} from '../../hooks/use-view-state-reducer/view-state-action-types'
import {useViews} from '../../hooks/use-views'

type UseTableHierarchy = {
  /** Whether or not the table should have hierarchy displayed or not */
  hierarchyEnabled: boolean
  /** Set the table hierarchy visibility state */
  setHierarchyEnabled: (viewNumber: number, enabled: boolean) => void
}

export const useTableHierarchy = (): UseTableHierarchy => {
  const memex_nested_sub_issues = useFeatureFlag('memex_nested_sub_issues')
  const {currentView, viewStateDispatch} = useViews()

  const enabled =
    memex_nested_sub_issues && (currentView?.localViewState?.layoutSettings?.table?.hierarchy?.enabled ?? false)

  const setEnabled = useCallback(
    (viewNumber: number, newEnabled: boolean): void => {
      if (!memex_nested_sub_issues) return
      viewStateDispatch({
        type: ViewStateActionTypes.SetTableHierarchyEnabled,
        viewNumber,
        enabled: newEnabled,
      })
    },
    [memex_nested_sub_issues, viewStateDispatch],
  )

  return {
    hierarchyEnabled: enabled,
    setHierarchyEnabled: setEnabled,
  }
}
